module.exports = __webpack_public_path__ + "static/img/error.60b3505.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error.jpeg
// module id = gVQo
// module chunks = 1